import { ReactNode } from "react";
import { Box, styled, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "600px",
  width: "100%",
  border: "1px solid",
  borderColor: theme.vars.palette.divider,
  backgroundColor: theme.vars.palette.background.paper,
  borderRadius: theme.spacing(2),
  paddingInline: theme.spacing(5),
  paddingBlock: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    paddingInline: theme.spacing(1.5),
    paddingBlock: theme.spacing(4),
  },
  [theme.breakpoints.down("sm")]: {
    paddingInline: theme.spacing(1),
    paddingBlock: theme.spacing(1.5),
  },
}));

type ChartCardProps = {
  title: string;
  children: ReactNode;
  toolbar?: ReactNode;
  legend: {
    key: string;
    label: string;
    color: string;
  }[];
};

export function ChartCard({
  title,
  legend,
  children,
  toolbar,
}: ChartCardProps) {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Typography
        variant={"bodyLargeMedium"}
        textAlign={"center"}
        component={"h2"}
        padding={0.5}
      >
        {title}
      </Typography>
      <Box
        padding={1}
        display={"flex"}
        gap={2.5}
        justifyContent={"center"}
        flexWrap={"wrap"}
      >
        {legend.map(({ key, label, color }) => (
          <Box key={key} display={"flex"} gap={1}>
            <Box
              sx={{
                backgroundColor: color,
                borderRadius: 0.5,
                height: "20px",
                width: "20px",
              }}
            />
            <Typography>{label}</Typography>
          </Box>
        ))}
      </Box>
      <Box flexGrow={1}>{children}</Box>
      {toolbar}
      <Typography
        textAlign={"center"}
        padding={1}
        variant={"bodySmallRegular"}
        color={"text.secondary"}
      >
        {t("Scroll or pinch to zoom")}
      </Typography>
    </Wrapper>
  );
}
